if (!customElements.get('avl-ingredient-details')) {
  customElements.define('avl-ingredient-details', class extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('[data-ingredient-dialog]');
      this.fallback = this.querySelector('[data-ingredient-fallback]');
      this.content = this.querySelector('[data-ingredient-content]');
      this.trigger = this.querySelector('[data-ingredient-open]');
      if (!this.dialog?.showModal || !this.fallback || !this.content || !this.trigger) return;
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.trigger.addEventListener('click', () => this.open(), options);
      this.querySelector('[data-ingredient-close]').addEventListener('click', () => this.dialog.close(), options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const bounds = this.dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) this.dialog.close();
      }, options);
      this.fallback.hidden = true;
      this.trigger.hidden = false;
    }
    open() {
      if (this.dialog.open) return;
      this.previousOverflow = document.body.style.overflow;
      this.querySelector('[data-ingredient-dialog-body]').append(this.content);
      this.dialog.showModal();
      this.isOpen = true;
      document.body.style.overflow = 'hidden';
      this.querySelector('[data-ingredient-dialog-body]').scrollTop = 0;
      this.querySelector('[data-ingredient-close]').focus({ preventScroll: true });
    }
    restore() {
      if (!this.isOpen) return;
      this.isOpen = false;
      document.body.style.overflow = this.previousOverflow || '';
      this.fallback.append(this.content);
      if (this.isConnected) this.trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.dialog?.close();
      this.restore();
      this.abort?.abort();
    }
  });
}
